// Staging environment
export const environment = {
  production: false,
  name: "staging",
  release: "0.0.35#258",
  baseUrl: "https://api-staging.yachtdrop.com",
  keycloakBaseUrl: "https://auth-staging.services.coara.xyz/realms/xdrop-staging/protocol/openid-connect/userinfo",
  googleMapsApiKey: "AIzaSyCwgCJkeA9WDZHX0gv4TxlCwvQ-zl56PV8",
};
